import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Component, effect, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';
import { StoreService } from 'src/app/common/services/store.service';
import { ReportService } from 'src/app/reports/services/report.service';

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-ttm-date-range',
  templateUrl: './ttm-date-range.component.html',
  styleUrls: ['./ttm-date-range.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
  ],
})

export class TtmDateRangeComponent {
  @Input() name!: any;
  @Input() required: boolean = false;
  @Input() isSubscription: boolean = false;
  @Output() ttmToggle : EventEmitter<boolean> = new EventEmitter();
  unitForm!: FormGroup;
  startDate: any = 'start Date';
  endDate: any = 'End Date';
  StartEndDate = new FormControl();
  trailing12 !: boolean;
  minStartDate = new Date(1970, 0, 1); // January is 0-indexed
  constructor(private controlContainer: ControlContainer,
    private reportService: ReportService,
  ) {
    effect(() => {
      this.trailing12 = this.reportService.ttmToggleVariable();

      if(!this.trailing12) {
        this.trailing12Month(this.reportService.ttmcustomValue());
      }else {
        this.patchPreviousValue();
      }

    })    // this.trailing12 = this.storeService.get('ttmToggle') ? true : false;
  }
  ngOnInit() {
    this.unitForm = this.controlContainer.control as FormGroup;
    this.patchPreviousValue();

  }
  ngOnChanges() {
    // formControl of unitForm group.
    this.StartEndDate = this.controlContainer.control as FormControl;
  }
  /**
   * This function is used to patch the existing value
   */
  patchPreviousValue() {
    if (this.StartEndDate.value) {
      let [startDateString, endDateString] = this.StartEndDate.value.split('to')
      let sDate = moment(new Date(startDateString)).format('DD-MM-YYYY');
      let eDate = moment(new Date(endDateString)).format('DD-MM-YYYY');
      const convertToDate = (dateString: any) => {
        const [day, month, year] = dateString.split('-').map(Number);
        return new Date(year, month - 1, day);
      };
      this.startDate = convertToDate(sDate);
      this.endDate = convertToDate(eDate);
    }
  }
  /**
   * function called when trailling twelve month button is enable.
   * this function set the value of endDate field as current date and start date value as past 12 month date.
   */
  trailing12Month(is_removed=false) {
    const today = new Date();
    this.endDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
    const minDate = new Date(today);
    minDate.setFullYear(minDate.getFullYear() - 1);
    minDate.setDate(minDate.getDate() + 1);
    this.startDate = `${minDate.getFullYear()}-${String(minDate.getMonth() + 1).padStart(2, "0")}-${String(minDate.getDate()).padStart(2, "0")}`;
    let finalDate = `${this.startDate}to${this.endDate}`;
    this.StartEndDate.patchValue(finalDate);
    if(is_removed){
        // this.reportService.ttmcustomValue.set(false);
        this.trailing12 = true;
        this.startDate = '';
        this.endDate = '';
        this.StartEndDate.patchValue('');
      }
  }
  /**
   * This function makes all the dates of calender disable which is smaller then start date.
   * @param date : date of the selected month
   * @returns
   */
  endDateFilter = (date: Date | null): boolean => {
    if (!date) return false;
    if (!this.startDate) return true; // If no start date, allow all
    // Only allow dates >= startDate
    return date >= this.startDate;
  };
  ngAfterViewInit() {
    if (!this.StartEndDate.value && !this.trailing12) this.trailing12Month();
  }
  /**
   * This function contains the logic related to toggle button.
   * @param event contains the input(used as checkbox) element.
   */
  onToggleChange(event: Event) {
    this.trailing12 = (event.target as HTMLInputElement).checked;
    this.ttmToggle.emit(this.trailing12);
    if (!this.trailing12) {
      this.trailing12Month();
    } else {
      this.startDate = '';
      this.endDate = '';
      this.StartEndDate.patchValue('');
    }
  }
  /**
   * funtion is called when the start or end date change.
   * @param startDate contains start date
   * @param endDate contains end date
   */
  onStartEndDateChange(startDate: any, endDate: any) {
    let sDate, eDate, finalDate = "";
    if(startDate) sDate = moment(new Date(startDate)).format('YYYY-MM-DD');
    if(endDate) eDate = moment(new Date(endDate)).format('YYYY-MM-DD');
    if(sDate && eDate) {
      finalDate = `${sDate}to${eDate}`;
    }else if(sDate) {
      finalDate = `${sDate}to`
    }else if(eDate) {
      finalDate = `to${eDate}`;
    }
    if(endDate < startDate) {
      this.endDate = ""
      this.StartEndDate.patchValue(sDate);
      return
    }
    console.log(finalDate);
    this.StartEndDate.patchValue(finalDate);
  }
  ngOnDestory() {
  }
}
